import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./ScheduleRouter'),
  loading: () => <Loading withContentWrapper />,
});

export const CategorySchedule = Loadable({
  loader: () => import('./CategorySchedule'),
  loading: () => <Loading withContentWrapper />,
});

export const List = Loadable({
  loader: () => import('./ScheduleList'),
  loading: () => <Loading withContentWrapper />,
});
